import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { render } from 'react-dom';
import AppRoute from './components/AppRoute/';
import './styles/css/index.css';
// Import provider to wrap all components so you can access store
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './image-loader/css/kick-image-loader.css';
import './image-loader/css/progressive-image.css';
import './image-loader/js/progressive-image.js';
import store from './store';

// Don't init sentry except for production
if (~document.location.hostname.indexOf('www.kickavenue.com')) {
	Sentry.init({
		dsn: 'https://2da624792abd4039bb44a5002b538b39@o292330.ingest.sentry.io/5537266',
		integrations: [
			new Integrations.BrowserTracing(),
		],

		// We recommend adjusting this value in production, or using tracesSampler
		// for finer control
		tracesSampleRate: 1.0,

		beforeSend(event, hint) {
			const error = hint.originalException;
			// Ignore 401 and 404 error
			if (
				error &&
				error.response &&
				error.response.status &&
				error.response.status === 401 ||
				error.response.status === 404
			) {
				return null;
			}

			// Ignore balance not enough to bid error
			if (
				error &&
				error.response &&
				error.response.data &&
				error.response.data.error &&
				error.response.data.error.message &&
				error.response.data.error.message == 'Your balance is not enough to enter bid systems!'
			) {
				return null;
			}

			return event;
		},
	});
}

render(
	<Sentry.ErrorBoundary fallback={'An error has occurred'}>
		<Provider store={store}>
			<>
				<AppRoute />
				<ToastContainer />
			</>
		</Provider>
	</Sentry.ErrorBoundary>,
	document.querySelector('#main'));
